module.exports = __webpack_public_path__ + "img/gallery-img-9.a54f97dd.jpg";